import React, { createContext, useState, useContext } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme] = useState('light'); // Remove theme switching functionality

  const lightTheme = {
    '--background': '#f8f9fa',
    '--surface': '#ffffff',
    '--surface-hover': '#f1f3f5',
    '--border': '#e9ecef',
    '--text-primary': '#212529',
    '--text-secondary': '#495057',
    '--text-tertiary': '#868e96',
    '--primary': '#228be6',
    '--primary-light': '#e7f5ff',
    '--primary-dark': '#1971c2',
    '--error': '#fa5252',
    '--error-light': '#ffe3e3',
    '--success': '#40c057',
    '--success-light': '#ebfbee',
    '--count-badge': '#e9ecef',
    '--notification-hover': '#f8f9fa',
    '--card-shadow': 'rgba(0, 0, 0, 0.1)',
    '--shadow-sm': '0 1px 3px rgba(0, 0, 0, 0.1)',
    '--shadow-md': '0 4px 6px rgba(0, 0, 0, 0.1)',
    '--shadow-lg': '0 10px 15px rgba(0, 0, 0, 0.1)',
    '--gradient-primary': 'linear-gradient(135deg, #228be6 0%, #1971c2 100%)',
    '--hover': '#f8f9fa',
    '--transition-normal': '0.2s ease',
  };

  return (
    <ThemeContext.Provider value={{ theme, colors: lightTheme }}>
      <div className="theme-provider" style={lightTheme}>
        {children}
      </div>
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}; 